import { render, staticRenderFns } from "./AuthSwitcher.vue?vue&type=template&id=2e9c161e&scoped=true"
import script from "./AuthSwitcher.vue?vue&type=script&lang=ts"
export * from "./AuthSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./AuthSwitcher.vue?vue&type=style&index=0&id=2e9c161e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.7__cache-loader@2.0.1_web_fe5e962fec43a62c82d69a5f09eb460e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c161e",
  null
  
)

export default component.exports